import EverTrue from 'app';
import { Modal, ModalHeader, ModalBody, Button, Icon } from '@evertrue/et-components';
import ActiveJourney from './active-journey';
import { PropTypes } from 'base/react-libs';
import { isBulkMessageType } from 'apps/cadences-v2/utils/cadence-enums';

const ActiveJourneysModal = ({ isOpen, closeModal, activeJourneys = [], activeV2Cadences = [], contactName = '' }) => {
  const totalCount = activeJourneys.length + activeV2Cadences.length;

  return (
    <>
      <Modal isOpen={isOpen} closeModal={closeModal} closeOnOutsideClick={true}>
        <ModalHeader title="Cadences" closeModal={closeModal} />
        <ModalBody>
          <div>
            <p className="active-journeys-modal--header">
              {contactName} is added to {totalCount} {totalCount === 1 ? 'Cadence' : 'Cadences'}.
            </p>
            {activeJourneys.map((journey) => (
              <ActiveJourney journey={journey} key={`v1-${journey.journey_id}`} contactName={contactName} />
            ))}
            {activeV2Cadences.map((cadence) => {
              const route = isBulkMessageType(cadence.cadenceType)
                ? `/cadences-v2/bulk-message/${cadence.journey_id}`
                : `/cadences-v2/${cadence.journey_id}`;
              return (
                <div className="active-journey" key={`v2-${cadence.journey_id}`}>
                  <Icon icon="cadences" iconKit="gt2" />
                  <div>
                    <Button type="simple" onClick={() => EverTrue.Navigator(route, true)}>
                      {cadence.journey_name}
                    </Button>
                    <p>Cadence 2.0</p>
                  </div>
                </div>
              );
            })}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

ActiveJourneysModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  activeJourneys: PropTypes.array,
  activeV2Cadences: PropTypes.array,
  contactName: PropTypes.string,
};

export default ActiveJourneysModal;
